<h2 class="outdated-title" mat-dialog-title>{{ "ONSIP_I18N.YOUR_APP_IS_OUTDATED" | translate }}</h2>
<div mat-dialog-content>
  <p>
    {{ "ONSIP_I18N.PLEASE" | translate }}
    <a target="_blank" class="update-link primary-500" href="https://www.onsip.com/app/download">{{
      "ONSIP_I18N.UPDATE" | translate
    }}</a>
    {{ "ONSIP_I18N.OR_USE_OUR" | translate }}
    <a target="_blank" class="web-link primary-500" href="https://app.onsip.com/app/#/login">{{
      "ONSIP_I18N.WEB_APP" | translate
    }}</a>
    {{ "ONSIP_I18N.TO_CONTINUE" | translate }}.
  </p>
</div>
